/*
 * @Descripttion: 分发人群包组件
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React from 'react';
import { Icon } from '@alifd/next';
import styles from '../index.module.scss';

/**
 * @param activeTagList-点击左侧标签统计出的所有选中标签
 * @param changeActiveTagValue-对标签选框进行了编辑，传到父组件去修改值
 * @param changeActiveList-点击每个取消图标，删除一个选中标签
 */

const ContentDiv = (tagItem={}) => {
  return <div>
    <div style={{fontSize: '14px', fontWeight: 'bold'}}>{tagItem?.name}</div>
    <div>{tagItem?.description}</div>
  </div>
}

const TagMappingCrowd = ({
  activeTagList = [], changeActiveList = (item, index, action) => {
  }
}) => {
  return (
    <>
      {
        activeTagList.map((subItem, subIndex) => {
          return (
            <div key={`contItem_${subIndex}`}>
              <div className={`${styles['tag-title']}`}>
                <span>人群包</span>
              </div>
              <section className={`${styles['tag-content']}`}>

                <div key={`subItem_${subIndex}`}>
                  <div key={subItem.id} className={`${styles.mb10}`}>
                    <section
                      className={`${styles['tag-name']}`}
                      style={{ position: 'relative' }}
                    >
                      <Icon
                        onClick={(event) => {
                          changeActiveList(subItem, subIndex, 'del');
                        }}
                        type="close"
                        size="xs"
                        style={{
                          cursor: 'pointer',
                          position: 'absolute',
                          top: '5px',
                          right: '15px',
                        }}
                      />
                    </section>
                    <div className={`${styles['editTag-content']}`}>
                      {
                        ContentDiv(subItem)
                      }
                    </div>
                  </div>
                </div>
              </section>
            </div>
          );
        })}
    </>
  );
};
export default TagMappingCrowd;
